import React, {useEffect, useState} from 'react';
import {DEFAULT_PAGE_SIZE} from '@app/constants/Common';
import SearchEmployerInput from "@pages/employer/list/SearchEmployerInput";
import OrderListByUpdatedTime from "@app/components/OrderListByUpdatedTime";
import DVTJCUVEmployerSummaryModal from "@pages/dvtjcuv/list/DVTJCUVEmployerSummaryModal";

export const EmployerListTableMode = {
    EMPLOYER_LIST: 1,
    RUN_DVTJCUV_SEARCH_CDD_EXCLUDE_EMPLOYERS: 2,
    DVTJCUV_SEARCH_EMPLOYER: 3,
}

const EmployerListTable = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [numberPages, setNumberPages] = useState(1);
    const [selectedCount, setSelectedCount] = useState(0);
    const [isSelectedAll, setSelectedAll] = useState(false);
    const [employerList, setEmployerList] = useState([]);
    const [searchCondition, setSearchCondition] = useState({});
    const [searchMode, setSearchMode] = useState(EmployerListTableMode.EMPLOYER_LIST);
    const [openDVTJCUVEmpSummaryModal, setOpenDVTJCUVEmpSummaryModal] = useState(false);
    const [selectRow, setSelectRow] = useState({});

    const {
        employers,
        allEmployerIds,
        totalCount,
        showBtnSelect,
        hideSearchForm,
        searchTitle,
        mode,
        onSearch,
        onDelete
    } = props

    const nextPage = () => {
        let currPage = currentPage + 1
        if (currPage <= numberPages) {
            searchCondition.page = currPage
            onSearch(searchCondition)
        } else {
            currPage = numberPages
        }
        setCurrentPage(currPage)
    };

    const onSearchClick = (condition) => {
        if (!condition.page) {
            condition.page = currentPage
        }

        condition.size = DEFAULT_PAGE_SIZE
        setSearchCondition(condition)
        return onSearch(condition)
    };

    const backPage = () => {
        let currPage = currentPage - 1
        if (currPage > 0) {
            searchCondition.page = currPage
            onSearch(searchCondition)
        } else {
            currPage = 0
        }
        setCurrentPage(currPage)
    };

    useEffect(() => {
        setEmployerList([...employers])
    }, [employers])

    useEffect(() => {
        setNumberPages(Math.ceil(totalCount/DEFAULT_PAGE_SIZE))
    }, [totalCount])

    useEffect(() => {
        if (mode) {
            setSearchMode(mode)
        }
    }, [mode])

    const openEmployerDetail = (employerId) => {
        if (!employerId) {
            employerId = employerList[0].id
        }
        const win = window.open(`/employer/edit/${employerId}`, "_blank");
        win.focus();
    }

    const openCreateJobScreen = (employerId) => {
        if (!employerId) {
            employerId = employerList[0].id
        }
        const win = window.open(`/job/add?employerId=${employerId}`, "_blank");
        win.focus();
    }

    const onSelectedItem = (index) => {
        employerList[index].isSelected = !employerList[index].isSelected
        if (employerList[index].isSelected) {
            setSelectedCount(selectedCount + 1)
        } else {
            setSelectedCount(selectedCount - 1)
            setSelectedAll(false)
        }
        setEmployerList([...employerList])
    };

    const onSelectedAll = () => {
        const canList = employerList.map(item => {
            item.isSelected = !isSelectedAll
            return item
        })

        setEmployerList([...canList])
        if (!isSelectedAll) {
            setSelectedCount(employerList.length)
        } else {
            setSelectedCount(0)
        }

        setSelectedAll(!isSelectedAll)
    };

    const createSelectedItemIds = (isAllEmpIds = false) => {
        if (isAllEmpIds) {
            return allEmployerIds
        }
        let empIds = []
        employerList.forEach(item => {
            if (item.isSelected) {
                empIds.push(item.id)
            }
        })

        return empIds
    }

    const onOpenEmpSummary = (item) => {
        setSelectRow(item)
        setOpenDVTJCUVEmpSummaryModal(true)
    }

    return (
        <>
            {!hideSearchForm &&
            <SearchEmployerInput
                searchTitle={searchTitle}
                onSearch={(condition) => onSearchClick(condition)}/>
            }
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Danh sách Employer ({totalCount})</h3>
                    {totalCount > 0 &&
                    <h3 className='card-title text-bold ml-3'>Page: {currentPage}/{numberPages}</h3>
                    }
                    <div className='card-tools'>
                        {searchMode === EmployerListTableMode.RUN_DVTJCUV_SEARCH_CDD_EXCLUDE_EMPLOYERS &&
                        <div className="btn-group mr-2">
                            <button type="button" className="btn btn-default">Actions</button>
                            <button type="button" className="btn btn-default dropdown-toggle dropdown-icon"
                                    data-toggle="dropdown">
                                <span className="sr-only">Toggle Dropdown</span>
                            </button>
                            <div className="dropdown-menu" role="menu">
                                    <button onClick={() => onDelete(createSelectedItemIds())}
                                            className={'dropdown-item'} type={'button'}>Xóa</button>
                            </div>
                        </div>
                        }
                        <OrderListByUpdatedTime onChange={(orderBy) => {
                            searchCondition.order_by = orderBy
                            onSearch(searchCondition)
                        }}/>
                        {numberPages > 1 &&
                        <ul className='pagination pagination-sm float-right mt-2 ml-5'>
                            <li className='page-item'>
                                <button className='page-link' type={'button'}
                                        onClick={() => backPage()}>&laquo;</button>
                            </li>
                            <li className='page-item'>
                                <button className='page-link' type={'button'}
                                        onClick={() => nextPage()}>&raquo;</button>
                            </li>
                        </ul>
                        }
                    </div>
                </div>
                <div className='card-body table-responsive p-0' style={{minHeight: 300}}>
                    <table
                        className='table table-hover table-bordered text-nowrap text-center'
                    >
                        <thead>
                        <tr>
                            {showBtnSelect &&
                                <th className={"pl-0"}>
                                    <input type="checkbox"
                                           style={{width: 20, height: 20}}
                                           checked={isSelectedAll}
                                           onChange={event => onSelectedAll(event)}
                                    />
                                </th>
                            }
                            <th>No.</th>
                            <th>Employer ID</th>
                            <th>Tên Employer (brief)</th>
                            {(searchMode === EmployerListTableMode.EMPLOYER_LIST
                                || searchMode === EmployerListTableMode.DVTJCUV_SEARCH_EMPLOYER
                            ) &&
                                <th>BD Status</th>
                            }
                            <th>Location (Tỉnh)</th>
                            <th>Industry</th>
                            <th>Function</th>
                            {searchMode === EmployerListTableMode.EMPLOYER_LIST &&
                                <>
                                    <th>Note</th>
                                    <th>Add time</th>
                                </>
                            }
                            {searchMode === EmployerListTableMode.DVTJCUV_SEARCH_EMPLOYER &&
                                <>
                                    <th>Lưu ý khi gửi CV</th>
                                </>
                            }
                            {/* {searchMode === EmployerListTableMode.EMPLOYER_LIST && */}
                            <th>Hành động</th>
                            {/* } */}
                        </tr>
                        </thead>
                        <tbody>
                        {employerList && employerList.length > 0 && employerList.map((employer, index) => (
                            <tr key={`employer_${index}`}>
                                {showBtnSelect &&
                                    <td style={{paddingLeft: '.75rem'}}>
                                        <input type="checkbox"
                                               style={{width: 20, height: 20}}
                                            // value={!!searchConditions.only_user_input}
                                               checked={employer.isSelected}
                                               onChange={() => onSelectedItem(index)}
                                        />
                                    </td>
                                }
                                <td>{employer.no ? employer.no : index + 1}</td>
                                <td>
                                    <a href="javascript:void(0)" onClick={() => openEmployerDetail(employer.id)}>
                                        {employer.id}
                                    </a>
                                </td>
                                <td>
                                    <a href="javascript:void(0)" onClick={() => openEmployerDetail(employer.id)}>
                                        {employer.brief_name}
                                    </a>
                                </td>
                                {(searchMode === EmployerListTableMode.EMPLOYER_LIST
                                    || searchMode === EmployerListTableMode.DVTJCUV_SEARCH_EMPLOYER
                                ) &&
                                <td>{employer.bd_status}</td>
                                }
                                <td>{employer.local_province}</td>
                                <td>{employer.industry}</td>
                                <td>{employer.function}</td>
                                {searchMode === EmployerListTableMode.EMPLOYER_LIST &&
                                    <>
                                        <td>{employer.notes}</td>
                                        <td>{employer.add_date_time}</td>
                                    </>
                                }
                                
                                {searchMode === EmployerListTableMode.DVTJCUV_SEARCH_EMPLOYER &&
                                    <td>{employer.note_when_send_cv}</td>
                                }
                                <td>
                                <div className="btn-group">
                                <button type="button" className="btn btn-default btn-sm">Actions</button>
                                <button type="button" className="btn btn-default btn-sm dropdown-toggle dropdown-icon"
                                        data-toggle="dropdown">
                                    <span className="sr-only">Toggle Dropdown</span>
                                </button>
                                <div className="dropdown-menu" role="menu">
                                    {/* {searchMode === EmployerListTableMode.EMPLOYER_LIST && */}
                                        <a href={"#"} onClick={() => openCreateJobScreen(employer.id)}
                                            rel="noopener noreferrer"
                                            className={'dropdown-item'}>
                                            Tạo Job
                                        </a>
                                    {/* } */}
                                    {mode === EmployerListTableMode.DVTJCUV_SEARCH_EMPLOYER &&
                                        <>
                                        <a href={`/dvtjcuv/list?employerId=${employer.id || ''}&&pipelineHistory=true`}
                                            target={'_blank'}
                                            rel="noopener noreferrer"
                                            className={'dropdown-item'}>
                                            Pipeline history
                                        </a>
                                        <button onClick={() => onOpenEmpSummary(employer)}
                                                type={'button'}
                                                className={'dropdown-item'}>
                                                Tổng hợp theo emp
                                        </button>
                                        </>
                                    }
                                    </div>
                                </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <div className='card-footer'>
                    <div className='card-tools'>
                        {numberPages > 1 &&
                            <ul className='pagination pagination-sm float-right'>
                                <li className='page-item'>
                                    <button className='page-link' type={'button'}
                                            onClick={() => backPage()}>&laquo;</button>
                                </li>
                            <li className='page-item'>
                                <button className='page-link' type={'button'}
                                        onClick={() => nextPage()}>&raquo;</button>
                            </li>
                        </ul>
                        }
                    </div>
                </div>
            </div>
            {openDVTJCUVEmpSummaryModal &&
                <DVTJCUVEmployerSummaryModal
                    employerId={selectRow.id}
                    employer={selectRow}
                    onClose={() => setOpenDVTJCUVEmpSummaryModal(false)}
                    isShow={openDVTJCUVEmpSummaryModal} />
            }
        </>
    );
};

export default EmployerListTable;
